<template>
    <span class="text-gray-900 fw-bolder mb-1 d-block fs-6">{{ name }}</span>
</template>

<script>
export default {
    props: ['name']
}
</script>